import { createFileRoute } from "@tanstack/react-router";
import BlueKcInsurance, { config } from "@/pages/BlueKcInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/blue-kc-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Blue KC TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Blue Cross and Blue Shield of Kansas City policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in.",
        },
        {
          property: "og:title",
          content: "Blue KC TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Blue Cross and Blue Shield of Kansas City policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/blue-kc-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/blue-kc-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BlueKcInsurance />;
}
